import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-faq-two',
  templateUrl: './faq-two.component.html',
  styleUrls: ['./faq-two.component.css']
})
export class FaqTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
